export enum OAuth2Auth0Prompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
}
